module.exports = __webpack_public_path__ + "media/images/workplace/patterns/3-a43cbead8b065b5b8b048042e4c11414.png";